import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getTransactionProductAll(params) {
	return client.get("transaksi/produk/mitra", {
		params: params,
	});
}

function getTransactionProductWait(params) {
	return client.get("transaksi/produk/mitra/menunggu", {
		params: params,
	});
}

function getDetailTransactionProduct(params) {
	return client.get("transaksi/produk/detail", {
		params: {
			id : params
		},
	});
}

function getTransactionApproveAll(params) {
	return client.get("transaksi/produk/stockist/member", {
		params: params,
	});
}

function getTransactionApproveWait(params) {
	return client.get("transaksi/produk/stockist/member/menunggu", {
		params: params,
	});
}

function addTransactionProductStockist(params) {
	return client.post("transaksi/produk/stockist", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addTransactionProductMitra(params) {
	return client.post("transaksi/produk/mitra", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approveTransactionProduct(params) {
	return client.post("transaksi/produk/stockist/member/approval", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getTransactionAdminProductAll(params) {
	return client.get("transaksi/produk/stockist/admin/stockist", {
		params: params,
	});
}

function getTransactionAdminProductWait(params) {
	return client.get("transaksi/produk/stockist/admin/menunggu", {
		params: params,
	});
}

export default {
	getTransactionProductAll,
	getTransactionProductWait,
	getDetailTransactionProduct,
	getTransactionApproveAll,
	getTransactionApproveWait,
	getTransactionAdminProductAll,
	getTransactionAdminProductWait,
	addTransactionProductStockist,
	addTransactionProductMitra,
	approveTransactionProduct,
};